import { HttpParams } from '@angular/common/http';

export function httpParamsUtil(obj: any): HttpParams {

  const preparedParams = Object.entries(obj).filter(([_, value]: [string, any]) => !!value)
    .reduce((acc, [key, value]) => {
      const preparedKey = (value instanceof Array) ? `${key}[]` : key;
      const preparedValue = (value instanceof Object) ? JSON.stringify(value) : String(value);

      return {
        ...acc,
        [preparedKey]: preparedValue,
      };
    }, {});

  const queryParams = new HttpParams({
      fromObject: preparedParams,
    });

  return queryParams;
}
